<template>
    <a href="#" @click.prevent="openDialog" v-html="linkText" :title="atitle"></a>
</template>

<script>
import ModalWrap from "@/components/base/modal/ModalWrap";

export default {
    props: {
        text: String,
        title: String,
        atitle: String,
        buttons: Object,
        footer: Object | String,
        saveData: Object | Array,
        component: Object,
        componentParams: Object,
        waitComponentLoaded: false,
        modalParams: Object,
        closeWatcher: Boolean,
        openWatcher: Boolean
    },
    data() {
        return {
            id: null,
            linkText: '',
        }
    },
    updated() {
        if (this.text) {
            this.linkText = this.text;
        }
    },
    created() {
        this.linkText = this.text;
        if (!this.linkText) {
            this.linkText = this.$t('Open dialog');
        }

        if (this.componentParams && !this.component) {
            throw new TypeError(this.$t('Specify component in props'));
        }
    },
    methods: {
        openDialog() {
            this.$modal.show(ModalWrap, { params: this }, this.modalParams);
        }
    },
    watch: {
        openWatcher: function (newVal) {
            if (newVal) {
                this.openDialog();
            }
        }
    }
}
</script>
<style>
.vue-dialog { border: 5px solid #f3f3f3; border-radius: 4px; box-shadow: 0 0 70px #bbb; }
.vue-dialog .dialog-c-title { padding: 7px 25px 7px 25px; background-color: #f3f3f3; }
.vue-dialog .dialog-c-title h1 { text-shadow: 1px 1px 0 white; position: relative; }
.vue-dialog .dialog-c-buttons { display: flex; align-items: center; }
.vue-dialog .dialog-c-buttons > * { padding: 0 5px; }
.vue-dialog .dialog-c-buttons > *:first-child { padding: 0; }
.vue-dialog .vue-dialog-content { flex: 1 0 auto; width: 100%; padding: 15px; font-size: 14px; height: 100%; overflow-y: auto; }
.vue-dialog-fixed-footer { padding-bottom: 100px; }
.vm--container.scrollable .vm--modal { margin: 10px 0; }
.vue-dialog .dialog-c-footer { display: flex; width: 100%; flex-flow: row nowrap; align-items: center; }
.vue-dialog .vue-dialog-fixed-footer .dialog-c-footer { position: absolute; bottom: 0; left: 0; }
.vue-dialog .dialog-c-close { position: absolute; right: 0; top: 50%; width: 24px; height: 24px; opacity: 0.3; margin-top: -12px; cursor: pointer; display: block; }
.vue-dialog .dialog-c-close:hover { opacity: 1; }
.vue-dialog .dialog-c-close:before, .vue-dialog .dialog-c-close:after { position: absolute; left: 15px; content: ' '; height: 24px; width: 2px; background-color: #333; }
.vue-dialog .dialog-c-close:before { transform: rotate(45deg); }
.vue-dialog .dialog-c-close:after { transform: rotate(-45deg); }
.vue-dialog-wrap { height: 100%; }
</style>